export const initPopover = tl => {
    const header = document.querySelector('#header');
    const popover = document.querySelector('#appointment');
    const closeButton = document.querySelector('#appointment .c-close');
    const success = document.querySelector('#success');

    if (!header || !popover || !closeButton || !success) return;

    const birthdate = popover.querySelector('.birthdate');
    const input = popover.querySelector('.birthdate input');

    if (birthdate && input) {
        input.addEventListener('focus', () => birthdate.classList.add('valid'));

        input.addEventListener('blur', () => {
            if (input.value !== '') return;
            birthdate.classList.remove('valid');
        });
    }

    let top = 0;
    let isOpen = false;

    // Show popover and toggle other elements' visibility.
    const showPopover = isVisible => {
        if (isVisible) {
            top = document.documentElement.scrollTop || document.body.scrollTop;

            // noinspection JSUnresolvedVariable
            dataLayer?.push({
                event: 'form_start',
            });
        }

        document.body.style.setProperty('margin-top', isVisible ? `-${top}px` : '');
        document.documentElement.classList.toggle('no-scroll', isVisible);

        if (!isVisible) window.scrollTo({ top: top });

        isVisible ? tl.play() : tl.timeScale(2).reverse(0);
        isOpen = isVisible;
    };

    // Hide popover action.
    const hidePopover = () => {
        window.history.pushState('', document.title, window.location.pathname);
        showPopover(false);
    };

    // Show popover on form post success or errors.
    if (popover.querySelector('.c-form.success, .errors')) showPopover(true);

    // Show popover on navigation button click.
    document.querySelectorAll('.navigation-button .menu-button').forEach(menuButton => {
        menuButton.addEventListener('click', e => {
            e.preventDefault();
            history.pushState(null, null, '#appointment');
            showPopover(true);
        });
    });

    // Show popover if hash is equal to popover id.
    if (window.location.hash.includes(popover.id)) showPopover(true);

    // Show success message if the hash is equal to the success id.
    if (window.location.hash.includes(success.id)) {
        window.history.pushState('', document.title, window.location.pathname);
        window.addEventListener('popstate', () =>
            window.history.pushState('', document.title, window.location.pathname)
        );
        success.showModal();
        setTimeout(() => success.close(), 7000);
    }

    // Show popover on button with correct href click.
    document.querySelectorAll(`[href="#${popover.id}"]`).forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            history.pushState(null, null, '#appointment');
            showPopover(true);
        });
    });

    // Hide popover on close button click.
    closeButton?.addEventListener('click', e => {
        e.preventDefault();
        hidePopover();
    });

    // Hide popover on "Escape" key click.
    window.addEventListener('keydown', e => {
        if (!isOpen) return;
        if (e.key === 'Escape') hidePopover();
    });

    const form = popover.querySelector('.c-form');
    const submit = popover.querySelector('.c-form-actions button[type="submit"]');

    if (!form || !submit) return;

    // Prevent double form submission on submit click.
    form.addEventListener(
        'submit',
        () => {
            submit.disabled = true;

            let patientStatus = '';

            form.querySelectorAll('[name="patient_form[status]"]').forEach(option => {
                if (option.checked) patientStatus = option.value;
            });

            // noinspection JSUnresolvedVariable
            dataLayer?.push({
                event: 'form_submission',
                form_patient: patientStatus, // takes the value of either ‘Neuer Patient’ or ‘Bestehender Patient’
                form_date: form.querySelector('[name="patient_form[appointment]"]')?.value ?? '', // takes the German language value of the selected preferred date
                form_day: form.querySelector('[name="patient_form[weekday]"]')?.value ?? '', // takes the German language value of the selected preferred day
                form_alternative_day: form.querySelector('[name="patient_form[alternativeWeekday]"]')?.value ?? '', // takes the German language value of the selected preferred alternative day
            });
        },
        { passive: true }
    );
};
